import { QcDialog } from '@tencent/qcvue2';

const dialog = {
  alert(
    {
      message = '',
      title = '',
      width = 420,
      icon = 'error',
      confirmText,
      language = 'zh', // 默认语言为 zh
    } = {},
    callback,
  ) {
    const defaultMessage = message || (language === 'en' ? 'Warning message' : '提示内容');
    const defaultTitle = title || (language === 'en' ? 'Warning' : '提示消息');

    QcDialog.alert({
      title: defaultTitle,
      message: defaultMessage,
      width,
      icon,
      confirmText,
    }).then(() => {
      if (callback) {
        callback();
      }
    });
  },
  confirm(
    {
      message = '',
      title = '',
      width = 420,
      icon = 'error',
      confirmText,
      cancelText,
      content,
      language = 'zh', // 默认语言为 zh
    } = {},
    callback,
  ) {
    const defaultMessage = message || (language === 'en' ? 'Warning message' : '提示内容');
    const defaultTitle = title || (language === 'en' ? 'Warning' : '提示消息');
    QcDialog.confirm({
      title: defaultTitle,
      message: defaultMessage,
      width,
      icon,
      confirmText,
      cancelText,
      content,
      closeTriggers: [],
    }).then(confirm => {
      callback(confirm);
    });
  },
};

export default dialog;
